export const openPage = page => window.open(page, '_blank')